Ext.define('SA.view.RankingGrid', {
    alias: 'widget.ranking-grid',
    extend: 'SA.view.ReportGrid',

    listeners: {
        'cell:click': function(grid, td, data, column) {
            var attribute = column.dataIndex,
                location = data.locationSeries,
                locationName = data.name;

            if (column.preventInteraction) {
                return;
            }

            if (attribute === 'name') {
                grid.showRowMenu(td, location, locationName);
            }
            else {
                grid.showCellMenu(td, attribute, location, locationName);
            }
        },

        'cell:mouseout': function(grid, td, data, column) {
            if (!column.preventInteraction) {
                Ext.fly(td).removeCls('sa-grid-cell-over');
            }
        },

        'cell:mouseover': function(grid, td, data, column) {
            if (!column.preventInteraction) {
                Ext.fly(td).addCls('sa-grid-cell-over');
            }
        },

        'column:click': function(grid, el, column) {
            var attribute = column.dataIndex;

            if (!column.preventInteraction) {
                grid.showColumnMenu(el, attribute);
            }
        },

        'column:mouseout': function(grid, td, column) {
            if (!column.preventInteraction) {
                Ext.fly(td).removeCls('sa-grid-cell-over');
            }
        },

        'column:mouseover': function(grid, td, column) {
            if (!column.preventInteraction) {
                Ext.fly(td).addCls('sa-grid-cell-over');
            }
        }
    },

    plugins: [{
        ptype: 'sa-grid-column-drag-reorder',

        afterMove(oldIndex, newIndex) {
            var grid = this.cmp,
                report = grid.projectView;

            report.moveAttribute(oldIndex, newIndex);

            report.save();
        }
    }],

    statics: {
        getLocationAttributesYearIncompatabilityWarning(projectView) {
            var attributes = projectView.getAttributes(),
                Locations = SA.data.LocationsCache,
                location = Locations.get(projectView.getLocation()),
                locations;

            if (location.type === 'radius') {
                locations = [Locations.get(location.locationSeries)];
            }
            else if (location.type === 'combination') {
                locations = location.locationSeries.map(locationId => Locations.get(locationId));
            }
            else {
                locations = [location];
            }

            return getFormattedWarningString();

            function getFormattedWarningString() {
                var locationYearsPlural = Ext.Array.unique(Ext.Array.flatten(locations.map(location => location.geographicReleases))).length > 1,
                    locationYearNoun = locationYearsPlural ? 'years' : 'year',
                    doesVerb = locationYearsPlural ? 'do' : 'does',
                    attributesPlural = attributes.length > 1,
                    attributeYears = SA.data.AttributesCache.getGeographicReleasesForAttributes(attributes),
                    attributeYearNoun = attributeYears.length > 1 ? 'years' : 'year',
                    variableNoun = attributesPlural ? 'variables' : 'variable';

                return `The ${locationYearNoun} of your location (${location.name}) ${doesVerb} not match the ${attributeYearNoun} of your data ${variableNoun}.`;
            }
        }
    },

    initComponent() {
        var reportModel = this.projectView;

        this.columns = this.buildColumns();
        this.data = [];

        this.callParent();

        this.refreshData();

        this.mon(reportModel, {
            buffer: 10,
            scope: this,

            'change:attribute': this.onChangeAttributes,
            'change:filter': this.onChangeFilter,
            'change:filterVisibility': this.onChangeFilter,
            'change:geographicUnit': this.onChangeGeographicUnit,
            'change:location': this.onChangeLocations,
            'change:maximumChildren': this.onChangeMaximumChildren,
            'change:sort': this.onChangeSort
        });

        this.mon(SA.data.LocationAliases, {
            buffer: 10,
            scope: this,

            'change': this.onChangeAlias
        });
    },

    buildColumns() {
        var projectView = this.projectView,
            attributeIds = projectView.getAttributes(),
            attributes = SA.data.AttributesCache.get(attributeIds),
            sortAttribute = projectView.getSortAttribute(),
            sortCls = 'sa-report-grid-sorted-' + projectView.getSortDirection();

        return [
            {
                align: 'right',
                dataIndex: 'rank',
                locked: true,
                preventInteraction: true,
                text: '',
                width: 58
            }, {
                cls: sortAttribute === 'name' ? sortCls : '',
                contentWidth: 250,
                dataIndex: 'name',
                encodeCells: false,
                forceRender: true,
                locked: true,
                text: 'Location',
                width: 150
            }
        ].concat(attributes.map((attribute, index) => {
            var id = attributeIds[index],
                column = {
                    align: 'right',
                    autoWidth: 215,
                    cls: id === sortAttribute ? sortCls : '',
                    contentWidth: true,
                    dataIndex: id,
                    encodeText: false,
                    text: this.getHeaderHtmlForAttribute(attribute),
                    width: 120
                };

            return column;
        }));
    },

    getRowCls(data) {
        if (data.strikeout) {
            return 'sa-report-grid-strikeout';
        }
    },

    onChangeAlias() {
        this.refreshData();
    },

    onChangeAttributes() {
        this.refreshColumns();
        this.refreshData();
    },

    onChangeFilter() {
        this.refreshData();
    },

    onChangeGeographicUnit() {
        this.refreshData();
    },

    onChangeLocations() {
        this.refreshData();
    },

    onChangeMaximumChildren() {
        this.refreshData();
    },

    onChangeSort() {
        this.refreshColumns();
        this.refreshData();
    },

    refreshColumns() {
        this.setColumns(this.buildColumns());
    },

    refreshData() {
        var me = this,
            data = this.data,
            reportModel = this.projectView,
            dataMap = reportModel.getReportData({fn: this.refreshData, scope: this}),
            locationsLength = dataMap.locationSeries.length,
            sortField = reportModel.getSortAttribute(),
            attributeIds = reportModel.getAttributes(),
            attributes = SA.data.AttributesCache.get(attributeIds),
            lastSortValue = {},
            index = 0,
            rowCount = reportModel.getRowCount(),
            strikeout = reportModel.getFilterQuery() && reportModel.getFilterVisibility() === 'strikeout',
            row, lastRank;

        for ( ; index < rowCount ; ++index) {
            row = data[index];

            if (!row) {
                row = {};

                data.push(row);
            }

            if (index < locationsLength) {
                row.name = dataMap.name[index];
                row.locationSeries = dataMap.locationSeries[index];
                row.locationAlias = SA.data.LocationAliases.get(row.locationSeries);

                row.name = Ext.util.Format.locationRenderer(row);

                attributes.forEach((attribute, attIndex) => {
                    var attributeId = attributeIds[attIndex],
                        value = dataMap[attributeId][index],
                        format = attribute.formatString;

                    if (typeof value !== 'undefined') {
                        value = SA.data.AttributesCache.formatValue(value, format);
                    }

                    row[attributeId] = value || '';
                });

                row.strikeout = strikeout && dataMap.filter[index] === false;
            }

            if (index < locationsLength && lastSortValue === row[sortField]) {
                row.rank = lastRank;
            }
            else {
                lastRank = row.rank = index + 1;
            }

            lastSortValue = row[sortField];
        }

        if (reportModel.isReportDataLoading()) {
            this.setLoading(true);
            this.removeCls('sa-report-grid-empty-cell-loading');

            if (!data.length) {
                data.push({}, {}, {}, {}, {});
            }
        }
        else {
            this.setLoading(false);
            this.addCls('sa-report-grid-empty-cell-loading');

            data.length = rowCount;
        }

        maybeShowLocationAttributesGeographicReleaseIncompatibilityWarning();

        this.setData(data);

        function maybeShowLocationAttributesGeographicReleaseIncompatibilityWarning() {
            var areRankingViewAttributesAndLocationIncompatible = reportModel.hasNoAttributeInLocationGeographicReleases();

            if (areRankingViewAttributesAndLocationIncompatible && !me.locationAttributesGeographicReleaseIncompatabilityWarningShown) {
                SA.warn(SA.view.RankingGrid.getLocationAttributesYearIncompatabilityWarning(reportModel));
                me.locationAttributesGeographicReleaseIncompatabilityWarningShown = true;
            }
        }
    },

    showCellMenu(el, attributeId, locationSeries, locationName) {
        this.showMenu(el, [
            {
                xtype: 'menu-attribute-caption'
            }, {
                xtype: 'menu-location-caption',
                emptyText: locationName
            }, {
                xtype: 'menu-create-map'
            }, {
                xtype: 'menu-create-ranking'
            }
        ], {attribute: attributeId, location: locationSeries});
    },

    showColumnMenu(el, attributeId) {
        var grid = this,
            items = [{xtype: 'menu-attribute-caption'}];

        if (attributeId !== 'name') {
            items.push(
                {
                    xtype: 'menu-add-remove-favorite-attribute'
                }, {
                    xtype: 'menu-view-attribute-metadata'
                }, {
                    xtype: 'menu-open-data-folder'
                }, {
                    xtype: 'add-other-years-menu-item',
                    model: this.projectView
                }, {
                    xtype: 'add-count-or-percent-menu-item',
                    model: this.projectView
                }, {
                    xtype: 'menu-remove-attribute'
                }
            );
        }

        if (grid.projectView.getSortAttribute() === attributeId) {
            items.push({
                text: 'Reverse sort order',

                handler() {
                    var view = grid.projectView;

                    view.setSort(attributeId, view.getSortDirection() === 'desc' ? 'asc' : 'desc');
                    view.save();
                }
            });
        }
        else {
            items.push(
                {
                    disabled: grid.isLoading,
                    text: attributeId === 'name' ? 'Sort locations A-Z' : 'Sort, smallest to largest',

                    handler() {
                        var view = grid.projectView;

                        view.setSort(attributeId, 'asc');
                        view.save();
                    }
                }, {
                    disabled: grid.isLoading,
                    text: attributeId === 'name' ? 'Sort locations Z-A' : 'Sort, largest to smallest',

                    handler() {
                        var view = grid.projectView;

                        view.setSort(attributeId, 'desc');
                        view.save();
                    }
                }
            );
        }

        grid.showMenu(el, items, {attribute: attributeId});
    },

    showRowMenu(el, locationSeries, locationName) {
        this.showMenu(el, [
            {
                xtype: 'menu-location-caption',
                emptyText: locationName
            }, {
                xtype: 'menu-add-remove-favorite-location'
            }, {
                xtype: 'menu-set-location-alias'
            }
        ], {location: locationSeries});
    }
});
